var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModuleTimesheet(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3949 3L13.4399 5.29504C13.4699 6.51004 14.4749 7.5 15.6899 7.5H20.2199C21.4649 7.5 22.4699 6.48 22.4699 5.25V3",
    fill: "#D6D6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3949 3L13.4399 5.29504C13.4699 6.51004 14.4749 7.5 15.6899 7.5H20.2199C21.4649 7.5 22.4699 6.48 22.4699 5.25V3",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 33H12C6.75 33 4.5 30 4.5 25.5V10.5C4.5 6 6.75 3 12 3H24C29.25 3 31.5 6 31.5 10.5V14",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26C33 29.864 29.864 33 26 33C22.136 33 19 29.864 19 26C19 22.136 22.136 19 26 19C29.864 19 33 22.136 33 26Z",
    fill: "#D6D6FA",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5971 28.2262L26.4271 26.9312C26.0491 26.7072 25.7411 26.1682 25.7411 25.7272V22.8572",
    fill: "#D6D6FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5971 28.2262L26.4271 26.9312C26.0491 26.7072 25.7411 26.1682 25.7411 25.7272V22.8572",
    stroke: "#6467EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleTimesheet);
export default __webpack_public_path__ + "static/media/module-timesheet.7a303619.svg";
export { ForwardRef as ReactComponent };